export default __webpack_public_path__ + "static/media/book1.86693c08.png";